/**
 *
 *  Footer -- mini-version
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 24/04/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
// import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// Images
import Insta from "./Insta";
import Facebook from "./Facebook";
import YouTube from "./YouTube";

const Footer = () => {
  return (
    <div className="tbk-bg-grey-light_ tbk-bg-[#F8F8F8] tbk-py-4 md:tbk-py-1">
      <div className="tbk-container tbk-mx-auto tbk-px-2">
        <div className="tbk-text-center md:tbk-flex md:tbk-justify-between md:tbk-text-left">
          <div className="tbk-mb-4 md:tbk-mb-0 md:tbk-flex">
            <div className="tbk-text-small tbk-mb-4 tbk-text-grey-main md:tbk-mr-7 md:tbk-mb-0 md:tbk-mr-0">
              © 2025 TruBe
            </div>
            <div className="tbk-flex tbk-justify-center">
              <div className="tbk-text-small tbk-text-grey-main">
                <Link
                  to="/contact"
                  className="tbk-whitespace-nowrap tbk-text-grey-main"
                >
                  Contact Us
                </Link>
              </div>
              <div className="tbk-text-small tbk-ml-3 tbk-mr-3 tbk-text-grey-main md:tbk-ml-4 md:tbk-mr-4">
                <a
                  href="/terms/Terms of Use and Booking.pdf"
                  className="tbk-whitespace-nowrap tbk-text-grey-main"
                  target="_blank"
                >
                  Terms and Conditions
                </a>
              </div>
              <div className="tbk-text-small tbk-text-grey-main">
                <a
                  href="/terms/TruBe - US Privacy Policy.pdf"
                  className="tbk-whitespace-nowrap tbk-text-grey-main"
                  target="_blank"
                >
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
          <div className="tbk-flex tbk-justify-center">
            <a
              href="https://instagram.com/trubeapp"
              className="tbk-text-grey-main hover:tbk-text-coral"
            >
              <Insta size="16px" className="tbk-mr-1" />
            </a>
            <a
              href="https://facebook.com/trubeapp"
              className="tbk-text-grey-main hover:tbk-text-coral"
            >
              <Facebook size="16px" className="tbk-mr-1" />
            </a>
            <a
              href="https://www.youtube.com/channel/UC07WjPV6YY_1GR1XJVwOgbg"
              className="tbk-text-grey-main hover:tbk-text-coral"
            >
              <YouTube size="16px" className="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

Footer.displayName = "Footer";

export default Footer;
